import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Constraint, ConstraintListResponse, ConstraintQueryParams, CreateConstraint, UpdateConstraint } from '@frontend/constraint/types';

export class ConstraintClient extends APIClient {
    public static readonly endpoint = '/slot-api/v1';

    public static async fetchApplicableConstraints(
        accountId: string,
        spotId: string,
        queryParams?: ApiQueryParams<ConstraintQueryParams>
    ): Promise<ConstraintListResponse> {
        return await this.apiPaginated<ConstraintListResponse, ConstraintQueryParams>(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/applicable-constraints`,
            queryParams
        );
    }

    public static async fetchConstraints(queryParams?: ApiQueryParams<ConstraintQueryParams>): Promise<ConstraintListResponse> {
        return await this.apiPaginated<ConstraintListResponse, ConstraintQueryParams>(`${this.endpoint}/constraints`, queryParams);
    }

    public static async resolveConstraints(ids: string[], field: string = 'id'): Promise<ConstraintListResponse> {
        return this.resolve<ConstraintListResponse>(`${this.endpoint}/constraints`, ids, field);
    }

    public static async deleteConstraints(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/constraints-delete`, { ids });
        return await this.handleVoidResponse(response);
    }

    public static async postSpotConstraint(accountId: string, spotId: string, constraint: CreateConstraint): Promise<Constraint> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/constraints`, constraint);
        return await this.handleResponse<Constraint>(response);
    }

    public static async fetchSpotConstraint(accountId: string, spotId: string, constraintId: string): Promise<Constraint> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/constraints/${constraintId}`);
        return await this.handleResponse<Constraint>(response);
    }

    public static async patchSpotConstraint(accountId: string, spotId: string, constraintId: string, body: UpdateConstraint): Promise<Constraint> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/constraints/${constraintId}`, body);
        return await this.handleResponse<Constraint>(response);
    }

    public static async deleteSpotConstraint(accountId: string, spotId: string, constraintId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/constraints/${constraintId}`);
        return await this.handleVoidResponse(response);
    }
}
